export enum ProcessingStatus {
  DRIVER_DEPARTED,
  DRIVER_NO_CONTRACT,
  CONTRACT_EXPIRED,
  UNAUTHORIZED,
  NO_RAMP,
}
